export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ede66ab7f2d897d9cab00befe10712209d6c02bd&name=pushAdClickData!'